import useSchaleStudents from "Hooks/useStudents";
import StudentMap from "Models/StudentMap";
import React from "react";

export default function StudentNameDatalist() {
	const {isReady} = useSchaleStudents();
	if (document.getElementById("studentNames") || !isReady) return null;
	return (<datalist id="studentNames">
		{new StudentMap().getStudentNames().map((sname, key) => (
				<option key={key} value={sname}></option>
			))
		}
	</datalist>);
}